<template>
    <div>
        <div class="wrap1200 breadcrumb">
            <breadcrumb></breadcrumb>
        </div>
        <router-view></router-view>
        <div class="usingMain wrap1200">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-for="(item,index) in videoName" :key="index" :label="item.name" :name="item.nickname">
                    <div class="videoPart">
                        <div class="itemVideo" v-for="(item,index) in videoList" @click="openVideoModal(item)">
                            <div class="imgPart">
                                <img :src="apiBaseURL+item.thumb_url">
                            </div>
                            <div class="titlePart">
                                {{ item.title }}
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div v-if="showModal" class="video-modal" @click.self="closeModal">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2>{{ currentVideo.title }}</h2>
                        <button class="close-btn" @click="closeModal">&times;</button>
                        <button class="fullscreen-btn" @click="toggleFullscreen">
                            {{ isFullscreen ? '退出全屏' : '全屏' }}
                        </button>
                    </div>
                    
                    <div class="video-container" ref="videoContainer">
                        <video-player 
                            ref="videoPlayer"
                            class="vjs-custom-skin"
                            :options="playerOptions"
                            @ready="onPlayerReady"
                        ></video-player>
                    </div>
                    
                    <p class="video-description">{{ currentVideo.desc_content }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Breadcrumb from '../components/Breadcrumb.vue';
import instance from '../api/axios';
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
import { getVideoName,getVideoList } from '../api/index'
export default {
    name: 'App',
    components: {
        Breadcrumb,
        videoPlayer
    },
    data() {
        return {
            showModal: false,
            activeName: 'all',
            isFullscreen: false,
            currentVideo: null,
            playerOptions: {
                autoplay: true,
                controls: true,
                preload: 'auto',
                fluid: true,
                aspectRatio: '16:9',  // 固定宽高比
                responsive: true,  // 响应式设计
                sources: []
            },
            videoName:[{
                name: '全部',
                id: 0,
                nickname:'all'
            }],
            videoList:[]
        };
    },
    computed: {
        apiBaseURL() {
            return instance.defaults.baseURL;
        }
    },
    created(){
        this.getVideoList();
        this.getVideoNameArr();

        const videoId = this.$route.query.video_id;
        if (videoId) {
            // 确保视频列表加载完成后再尝试打开弹窗
            this.$nextTick(() => {
                this.findAndOpenVideo(videoId);
            });
        }
    },
    methods: {
        findAndOpenVideo(videoId) {
            const foundVideo = this.videoList.find(video => video.id == videoId);
            if (foundVideo) {
                this.openVideoModal(foundVideo);
            } else {
                console.warn(`未找到ID为${videoId}的视频`);
            }
        },
        handleClick(tab, event) {
            // this.tabIndex = tab.index;
            console.log(tab.index);
            this.getVideoList(this.videoName[tab.index].id);
        },
        getVideoList(cid){
            const category_id = cid ? cid : 0
            getVideoList({category_id:category_id}).then(result => {
                let res = result.data;
                this.videoList = res.data;
                console.log(this.videoList,'this.videoList');
                const videoId = this.$route.query.video_id;
                if (videoId && !this.showModal) {
                    this.findAndOpenVideo(videoId);
                }
            })
        },
        getVideoNameArr(){
            getVideoName().then(result => {
                let res = result.data;
                if(res.code == 1){
                    this.videoName.push(...res.data);
                }
                console.log(res,'res')
            })
        },
        openVideoModal(video) {
            console.log(123456)
            console.log(video,'video')
            this.currentVideo = video
            this.playerOptions.sources = [{
                src: this.apiBaseURL+video.video_url,
                type: video.type
            }]
            this.showModal = true
            
            // 确保DOM更新后设置海报
            this.$nextTick(() => {
                try {
                    if (this.$refs.videoPlayer && this.$refs.videoPlayer.player) {
                    this.$refs.videoPlayer.player.poster(this.apiBaseURL + video.thumb_url);
                    }
                } catch (error) {
                    console.error('设置海报失败:', error);
                }
            })
        },
        
        closeModal() {
            this.showModal = false
            this.isFullscreen = false
            // 暂停当前视频
            if (this.$refs.videoPlayer) {
                this.$refs.videoPlayer.player.pause()
            }
            if (this.$route.query.video_id) {
                this.$router.replace({ query: null });
            }
        },
        
        toggleFullscreen() {
            if (!this.isFullscreen) {
                this.enterFullscreen()
            } else {
                this.exitFullscreen()
            }
        },
        
        enterFullscreen() {
            // 改为让播放器本身进入全屏，而不是容器
            if (this.$refs.videoPlayer) {
                const player = this.$refs.videoPlayer.player;
                if (player.requestFullscreen) {
                    player.requestFullscreen();
                } else if (player.webkitRequestFullscreen) {
                    player.webkitRequestFullscreen();
                } else if (player.msRequestFullscreen) {
                    player.msRequestFullscreen();
                }
                this.isFullscreen = true;
            }
        },
        
        exitFullscreen() {
            if (document.exitFullscreen) {
                document.exitFullscreen()
            } else if (document.webkitExitFullscreen) { /* Safari */
                document.webkitExitFullscreen()
            } else if (document.msExitFullscreen) { /* IE11 */
                document.msExitFullscreen()
            }
            this.isFullscreen = false
        },
        
        onPlayerReady(player) {
            console.log('播放器已就绪', player)
            // 监听全屏变化
            document.addEventListener('fullscreenchange', this.handleFullscreenChange)
            document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange)
            document.addEventListener('msfullscreenchange', this.handleFullscreenChange)
        },
        
        handleFullscreenChange() {
            if (this.$refs.videoPlayer) {
                this.isFullscreen = this.$refs.videoPlayer.player.isFullscreen();
            }
        }
    }
}
</script>
<style>
.wrap1200 {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
}
.usingMain{
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px;
    min-height: 450px;
}
.videoPart{
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding: 0 10px;
    .itemVideo{
        width: 23%;
        margin: 0 10px 32px 10px;
        box-sizing: border-box;
        .imgPart{
            width: 100%;
            img{
                width: 100%;
                border-radius: 8px;
            }
        }
        .titlePart{
            font-size: 14px;
            font-weight: bold;
            margin-top: 2px;
        }
    }
}
.videoPart .itemVideo{
    width: 23%;
    margin: 0 10px 32px 10px;
    box-sizing: border-box;
}
.videoPart .itemVideo .imgPart{
    width: 100%;
}
.videoPart .itemVideo .imgPart img{
    width: 100%;
    border-radius: 8px;
}
.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 1000px;
  overflow: hidden;
  position: relative;
}

.modal-header {
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
}

:fullscreen .video-js {
  width: 100% !important;
  height: 100% !important;
  max-height: none;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  position: absolute;
  right: 15px;
  top: 10px;
}

.fullscreen-btn {
  background: #42b983;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 40px;
}

.video-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 比例 */
  height: 0;
  overflow: hidden;
  background: #000;
}

.video-container .video-js {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-description {
    padding: 15px 20px;
    color: #666;
    max-height: 100px;
    overflow-y: auto;
}

/* 自定义video.js皮肤 */
.vjs-custom-skin {
  border-radius: 4px;
  overflow: hidden;
}

/* 全屏样式 */
:fullscreen .modal-content {
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
  border-radius: 0;
}

:-webkit-full-screen .modal-content {
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
  border-radius: 0;
}

:-ms-fullscreen .modal-content {
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
  border-radius: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/usingTutorials.vue